(function ($) {
	'use strict';

	$(function () {
		const $item = $('.js-offcanvas-menu-item');
		const $trigger = $('.js-offcanvas-menu-trigger');
		const $submenu = $('.js-offcanvas-menu-submenu');
		const $back = $('.js-site-offcanvas-back');
		const $offcanvas = $('.js-site-offcanvas');

		const activeClass = 'is-active';
		const offcanvasActiveClass = 'site-offcanvas--is-active';
		const overflowClass = 'u-overflow-hidden';

		$back.removeClass(activeClass);

		// Add heading to each submenu
		$submenu.each(function () {
			const $parent = $(this).closest($item).find($trigger).first();
			const title = $parent.text().trim();
			const link = $parent.attr('href') || '#';
			const target = $parent.attr('target') || '_self';

			$(this).prepend(`<div class="offcanvas-menu-submenu__title  js-offcanvas-menu-submenu-title">${title}</div>`);

			if (link !== '#') {
				$(this).find('ul').first().prepend(
					`<li class="offcanvas-menu-submenu__item js-offcanvas-menu-item is-child">
						<a href="${link}" target="${target}" class="offcanvas-menu-submenu__link">
							<span class="offcanvas-menu-submenu__label">${title} Overview
						</a>
					</li>`
				);
			}
		});

		$trigger.on('click', function (event) {
			event.preventDefault();
			$(this).parent().find($submenu).first().addClass(activeClass);
			$back.addClass(activeClass);
		});

		$back.on('click', function () {
			$submenu.filter(`.${activeClass}`).last().removeClass(activeClass);

			if ($submenu.filter(`.${activeClass}`).length === 0) {
				$back.removeClass(activeClass);
			}
		});

		$($submenu).find('a').not($trigger).on('click', function () {
			$offcanvas.removeClass(offcanvasActiveClass);
			$('body').removeClass(overflowClass);
		});
	});
})(jQuery);
